import config from "./config";

//common config
export const WEBNAME = config.webName;
export const ADDRESS = config.address;
export const EMAIL = config.email;
export const MOBILE = config.mobile;
export const WHATSAPP = config.whatsapp;
export const NO_IMAGE = config.noImage;
export const DEVS_SITE = config.devsSite;

//env config
export const WEB_URL = config.webLink;
export const SERVER = config.server;
export const SERVER_API = config.serverapi;
export const IMAGE_URL = config.imagepath;

//web route
export const LOGIN = config.login;
export const LOGIN_SUCCESS = config.loginSuccess;
export const DASHBOARD = config.dashboard;
export const VEHICLE_SALE = config.vehicle_sale;
export const SHOP_SALE = config.shop_sale;
export const PAYMENT_PROCCESS = config.payment_proccess;
export const PAYMENT_HISTORY = config.payment_history;
export const MANAGE_CUSTOMERS = config.manage_customers;
export const REMITTANCE = config.remittance;
export const REPORT_BY_CUSTOMER = config.report_by_customer;
export const REPORT_BY_DATE = config.report_by_date;
export const REPORT_BY_INQUERY = config.report_by_inquery;
export const REPORT_BY_REMITTANCE = config.report_by_remittance;
export const SYSTEM_LOGS = config.system_logs;
export const MANAGE_USERS = config.manage_users;
export const MANAGE_DEALERS = config.manage_dealers;
export const MANAGE_SALES_PERSONS = config.manage_sales_persons;
export const MANAGE_VEHICLE = config.manage_vehicle;
export const VEHICLE_CONFIG = config.vehicle_config;
export const MANAGE_STOCK_TRANSFER = config.manage_stock_transfer;
export const DEALER_MONITOR = config.dealer_monitor;
export const VEHICLE_HISTORY = config.vehicle_history;
export const STOCK_TRANSFER_HISTORY = config.stock_transfer_history;
export const STOCK_REPORTS = config.stock_reports;
export const FINANCIAL_REPORTS = config.financial_reports;
export const DPMC_REMITTANCE_REPORT = config.dpmc_remittance_report;
export const SALES_INVOICE_BREAKDOWN = config.sales_invoice_breakdown;
export const DAY_SUMMARY = config.day_summary;
export const MANAGE_BANK = config.manage_bank;
export const MANAGE_TICKETS = config.manage_tickets;
export const TRIGGERED_EMAILS = config.triggered_emails;
export const MANAGE_CREDIT = config.manage_credit;
export const MANAGE_GRN = config.manage_grn;
export const RETURNED_VEHICLE_REPORT = config.returned_vehicle_report;
export const REPORT_BY_SALES_PERSON = config.report_by_sales_person;
export const MANAGE_PRODUCTS = config.manage_products;
export const OFFER_FOR_INQUIRY = config.offer_for_inquiry;
export const REPORT_BIKE_THREEWHEEL = config.report_bike_threewheel;
export const CUSTOM_REPORTS = config.custom_reports;
export const NODE_REPORTS = config.node_reports;
export const AI_AGENT = config.ai_agent;
export const SUB_DEALER_CASH_REPORT = config.sub_dealer_cash_report;


//commons
export const APPLOGO = config.appLogo;
export const SIGNIN_BG = config.signInBg;
export const PAGE_SIZE = 10;
export const DEBOUNCED_SEARCH_QUERY = 500;
